import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';

import { DsButton } from '@frontend/ui/button';
import { DsCard, DsCardContent } from '@frontend/ui/card';
import { DsDivider } from '@frontend/ui/divider';
import { CurrencyPipe, DeviceService, DslService, DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { AccountMenuItemBase } from '../account-menu-item-base';
import { WalletDetailModalComponent } from './wallet-detail/wallet-detail.modal.component';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        DsCard,
        DsCardContent,
        DsButton,
        DynamicComponentDirective,
        MatBottomSheetModule,
        CurrencyPipe,
        ImageComponent,
        DsDivider,
    ],
    selector: 'vn-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['../../../../../../themepark/themes/whitelabel/components/wallet/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WalletComponent extends AccountMenuItemBase implements OnInit {
    totalBalanceItem: MenuContentItem | undefined;
    bonusBalanceItem: MenuContentItem | undefined;
    withdrawableBalanceItem: MenuContentItem | undefined;
    totalBalance: number;
    bonusBalance: number;
    withdrawableBalance: number;
    ctaItems: MenuContentItem[];
    showWarningIcon: boolean;

    private readonly bottomSheet = inject(MatBottomSheet);
    private readonly modalDialog = inject(MatDialog);
    private readonly deviseService = inject(DeviceService);
    private dslService = inject(DslService);

    ngOnInit(): void {
        this.totalBalanceItem = this.item.children.find((x) => x.name === 'total');
        if (this.totalBalanceItem?.parameters['formula']) {
            this.dslService.evaluateExpression<number>(this.totalBalanceItem?.parameters['formula']).subscribe((x) => (this.totalBalance = x));
        }

        this.bonusBalanceItem = this.item.children.find((x) => x.name === 'bonus');
        if (this.bonusBalanceItem?.parameters['formula']) {
            this.dslService.evaluateExpression<number>(this.bonusBalanceItem?.parameters['formula']).subscribe((x) => (this.bonusBalance = x));
        }

        this.withdrawableBalanceItem = this.item.children.find((x) => x.name === 'withdrawable');
        if (this.withdrawableBalanceItem?.parameters['formula']) {
            this.dslService
                .evaluateExpression<number>(this.withdrawableBalanceItem?.parameters['formula'])
                .subscribe((x) => (this.withdrawableBalance = x));
        }

        this.ctaItems = this.item.children.filter((x) => x.type === 'cta');
    }

    showBalance() {
        const parameters = {
            data: { item: this.item.children.filter((x) => x.type !== 'cta') },
            panelClass: 'wallet-detail-dialog',
        };

        if (this.deviseService.isMobile) {
            this.bottomSheet.open(WalletDetailModalComponent, parameters);
        } else {
            this.modalDialog.open(WalletDetailModalComponent, parameters);
        }
    }
}
